import { render, staticRenderFns } from "./ProductSold.vue?vue&type=template&id=2628257c"
import script from "./ProductSold.vue?vue&type=script&lang=js"
export * from "./ProductSold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports